<template>
    <div class="row stdenis-about">
        <div class="white-overlay">
            <div class="container-fluid" style="position: relative">
                <div class="row download-bg">
                    <div class="col-12">
                        <img src="../assets/images/backgrounds/download_hand.png"
                             alt="download image"
                        >
                        <div class="float-md-right download-txt-blk">
                            <div class="download-text">
                                <h1>Parish Bulletin</h1>
                                <h6>The app is currently available on Google Playstore for Android users.</h6>
                                <div class="row mt-5">
                                    <div class="col-12 col-lg-5">
                                        <a href="https://apps.apple.com/us/app/id1517548701" target="_blank" class="href-link">
                                            <img src="../assets/images/backgrounds/download_ios_btn.png" alt="ios download">
                                        </a>
                                    </div>
                                    <div class="col-12 col-lg-6 ">
                                        <a href="https://play.google.com/store/apps/details?id=com.grandilo.parishbulletin" target="_blank" class="href-link">
                                            <img src="../assets/images/backgrounds/download_android.png" alt="ios download">
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // import {firestoreDB} from "../config/firebase";


    export default {
        name: "AppDownload",
        data(){
            return {
                societiesList: []
            }
        },
        methods:{
            populateSocieties(){

            }
        },
        created() {
            window.scrollTo(0, 0);
        }
    }
</script>

<style scoped>
    @media screen and (min-width: 320px){
        .stdenis-about{

        }
        .stdenis-about .download-bg:before{
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0,0,0,.5);
        }
        .stdenis-about .download-bg{
            min-height: 500px;
            background: url("../assets/images/backgrounds/download-bg.jpg") no-repeat fixed center;
            background-size: cover;
            text-align: left;
        }
        .stdenis-about .download-bg img{
            width: 300px;
            height: 400px;
            margin-left: 0px;
            margin-top: 100px
        }
        .stdenis-about .download-bg .download-text{
            padding: 50px 10px;
            padding-top: 0px;
            text-align: left
        }
        .download-txt-blk{
            height: 100%;
            width: 100%
        }
        .href-link{
            display: inline-block;
        }
        .href-link img{
            width: 200px!important;
            height: 61px!important;
            margin: 0!important;
        }
        h1,h6{
            color: #ffffff!important;
        }
    }
    @media screen and (min-width: 1024px){
        .stdenis-about .download-bg img{
            margin-left: 200px;
        }
        .stdenis-about .download-bg .download-text{
            padding: 50px;
            padding-top: 150px
        }
        .download-txt-blk{
            width: 50%
        }
    }
</style>